import { call, put } from "redux-saga/effects";
import * as Api from "../../api";
import * as actions from "../actions";

export default function* postNHSReferencesFormSaga({ payload }) {
  try {
    const { formContent } = payload;
    yield call(Api.postNHSReferencesForm, formContent);
  } catch (error) {
    yield put(actions.addError("post-nhs-references-form", error));
  }
}
